import { render } from "./ModalAdicionarHistorico.vue?vue&type=template&id=5d3094e2&scoped=true"
import script from "./ModalAdicionarHistorico.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarHistorico.vue?vue&type=script&lang=js"

import "./ModalAdicionarHistorico.vue?vue&type=style&index=0&id=5d3094e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3094e2"]])

export default __exports__